import {
  useQuery,
  useMutation,
  useQueryClient,
  UseMutationResult,
  UseQueryResult
} from 'react-query'
import { requestWithdrawal, fetchWithdrawalHistory } from 'api/withdrawals'

type WithdrawalHistoryEntry = {
  id: number
  amount: number
  status: string
  createdAt: string
}

export function useMutateRequestWithdrawal(): UseMutationResult<
  { id: number },
  unknown,
  { amount: number; bankAccountId: number; idempotencyKey?: string }
> {
  const qc = useQueryClient()
  return useMutation(requestWithdrawal, {
    onSuccess: () => {
      qc.invalidateQueries(['wallet'])
      qc.invalidateQueries(['withdrawal-history'])
    }
  })
}

export function useWithdrawalHistory(): UseQueryResult<
  WithdrawalHistoryEntry[]
> {
  return useQuery(['withdrawal-history'], fetchWithdrawalHistory, {
    staleTime: 60_000
  })
}
